import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { hideMenu, showMenu } from '../../store/actions';
import TopNavBar from '../../components/TopNavBar/TopNavBar';
import Footer from '../../components/Footer/Footer';
import withGlobals from '../../withGlobals';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

import './UpdatePaymentMethod.css';

import { Elements } from '@stripe/react-stripe-js';

export class UpdatePaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
    this.stripePromise = loadStripe(
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    );
  }

  componentDidMount() {
    document.title = 'Update Payment Method - Sure';
  }

  handleSuccess = () => {
    this.setState({ success: true });
  };

  render() {
    return (
      <div className="UpdatePaymentMethod">
        <TopNavBar
          isMenuOpen={this.props.isMenuOpen}
          onHideMenu={this.props.hideMenu}
          onShowMenu={this.props.showMenu}
        />
        <div className="UpdatePaymentMethod-content Container">
          {this.state.success ? (
            <h2>Your payment details have been updated.</h2>
          ) : (
            <>
              <h1>Update Your Payment Method</h1>
              <Elements stripe={this.stripePromise}>
                <ElementsConsumer>
                  {({ elements, stripe }) => (
                    <CheckoutForm
                      elements={elements}
                      stripe={stripe}
                      linkToken={this.props.location.query.linkToken}
                      onSuccess={this.handleSuccess}
                    />
                  )}
                </ElementsConsumer>
              </Elements>
            </>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isMenuOpen: state.isMenuOpen,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showMenu: () => dispatch(showMenu()),
    hideMenu: () => dispatch(hideMenu()),
  };
};

const enhance = compose(
  withRouter,
  withGlobals(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(UpdatePaymentMethod);
